import { Injectable } from '@angular/core';
import { Benutzer } from '@karl/entities';
import { map, Observable, tap } from 'rxjs';
import { RestUserService } from '../../../rest/user.service';
import { RouterService } from '../../services/router.service';
import { PayloadUtil } from '../../util/payload.util';
import { fromLocalStorage, fromSessionStorage } from '../store.service';

export interface UserSettingData {
  settings: SettingData[];
}

export interface SettingData {
  id: string;
  comment: string;
  color: string;
}

@Injectable({providedIn: 'root'})
export class UserSettingStore {

  readonly settingKey = 'usersettings';
  readonly currentSettings = fromLocalStorage<UserSettingData>(this.settingKey);

  updateSettings(data: SettingData[]): void {
    this.currentSettings.set({
      settings: data
    });
  }

  public clearSettings(): void {
    this.currentSettings.set(null);
  }

}
